import { render } from "./sessionConference.vue?vue&type=template&id=8cffb45a&scoped=true"
import script from "./sessionConference.vue?vue&type=script&lang=js"
export * from "./sessionConference.vue?vue&type=script&lang=js"

import "./sessionConference.vue?vue&type=style&index=0&id=8cffb45a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cffb45a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
